// new game flow:
// -> GameActionRequest.CREATE_GAME
// <- SettingsTO
// <- GameNotificationTO (?)
// -> SettingsTO
// <- GameNotificationTO.CREATEGAME_SUCCESSFUL
// <- GameNotificationTO.ENTERGAME_SUCCESSFUL
import { writable } from 'svelte/store';
import ConnectionStore from './connection';
import LobbyStore from './lobby';
const createStore = () => {
    const runningGames = writable([]);
    const openNewGame = (gameType) => ConnectionStore.send({ actionRequest: 'CREATE', gameType });
    ConnectionStore.onSettings(({ detail: { gameId, settings } }) => runningGames.update((games) => games.concat({ gameId, title: 'New Game', stage: 'CREATE', settings })));
    LobbyStore.openGames.subscribe((openGames) => {
        console.log('open games update', openGames);
        runningGames.update((games) => games.map((game) => {
            const openGame = openGames.find(({ gameId }) => gameId === game.gameId);
            if (!openGame) {
                return game;
            }
            console.log('update game?');
            if (!game.gameTypeName) {
                game.title = openGame.gameTypeName;
                game.gameTypeName = openGame.gameTypeName;
                game.gameOwner = openGame.gameOwner;
                game.settings = openGame.settings;
                game.minPlayers = openGame.minPlayers;
                game.maxPlayers = openGame.maxPlayers;
                console.log('set game type', game);
            }
            if (game.currentPlayers !== openGame.currentPlayers) {
                game.currentPlayers = openGame.currentPlayers;
                console.log('update players');
            }
            return game;
        }));
    });
    ConnectionStore.onGameNotification(({ detail: notification }) => {
        runningGames.update((games) => {
            const game = games.find(({ gameId }) => gameId === notification.gameId);
            if (game) {
                console.warn('Incoming GameNotification', notification);
                switch (notification.notification) {
                    case 'CREATEGAME_FAILED':
                    case 'CREATEGAME_ABORTED':
                        return games.filter(({ gameId }) => gameId !== notification.gameId);
                    case 'CREATEGAME_SUCCESSFUL':
                    case 'ENTERGAME_SUCCESSFUL':
                        game.stage = 'OPEN';
                        return games;
                    default:
                        console.warn('Unhandled GameNotification', notification);
                        return games;
                }
            }
            else {
                console.warn('Could not find game for GameNotification', notification, games);
            }
        });
    });
    const startGame = (game, settings) => {
        console.log('send settings to server', settings);
        ConnectionStore.send({ gameId: game.gameId, settings });
    };
    const messagesPerGame = {};
    const getMessagesPerGame = (gameId) => {
        const existingWritable = messagesPerGame[gameId];
        if (existingWritable) {
            return existingWritable;
        }
        const newWritable = writable([]);
        messagesPerGame[gameId] = newWritable;
        return newWritable;
    };
    ConnectionStore.onGameChatMessage((msg) => getMessagesPerGame(msg.detail.gameId).update((msgs) => msgs.concat(msg.detail)));
    const sendChatMessage = (message, gameId) => {
        ConnectionStore.loggedIn.subscribe((loggedIn) => {
            if (loggedIn)
                ConnectionStore.username.subscribe((username) => {
                    ConnectionStore.send({
                        gameId,
                        message,
                        senderName: username,
                    });
                })();
        })();
    };
    return {
        runningGames: { subscribe: runningGames.subscribe },
        openNewGame,
        startGame,
        chatMessages: (gameId) => ({
            subscribe: getMessagesPerGame(gameId).subscribe,
        }),
        sendChatMessage,
    };
};
const gamesStore = createStore();
export default gamesStore;
